export default __webpack_public_path__ + "assets/images/Triple_Energy_Burst_01_O_RGB_Yellow_394x197_png-8_@2x.png";